import { render, staticRenderFns } from "./NuevoElemento.vue?vue&type=template&id=4ec528c8"
import script from "./NuevoElemento.vue?vue&type=script&lang=js"
export * from "./NuevoElemento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports